module.exports = __webpack_public_path__ + "static/media/SWSCRC1-20.689796ca.mp3";